import type { EcommerceItem } from './ecommerce-types';

export interface TfPixelEcommercePayload {
  currency?: string;
  items?: Array<Record<string, unknown>>;
  transaction_id?: string;
  value?: number;
}

function stripUndefined<T extends Record<string, unknown>>(obj: T): T {
  const out = { ...obj };
  for (const key of Object.keys(out)) {
    if (out[key] === undefined) delete out[key];
  }
  return out;
}

/** Maps a GA4-style line item to the full TFP collect payload shape (parity with dataLayer items[]). */
export function mapEcommerceItemToTfPixelItem(item: EcommerceItem): Record<string, unknown> {
  return stripUndefined({
    item_id: String(item.item_id ?? ''),
    item_group_id: String(item.item_group_id ?? item.item_id ?? ''),
    item_variant_id: item.item_variant_id,
    item_name: item.item_name,
    item_variant: item.item_variant,
    item_color: item.item_color,
    item_size: item.item_size,
    item_sku: item.item_sku,
    item_category: item.item_category,
    item_category2: item.item_category2,
    item_brand: item.item_brand,
    item_list_name: item.item_list_name,
    item_list_id: item.item_list_id,
    index: item.index,
    price: item.price ?? 0,
    compare_at_price: item.compare_at_price,
    discount: item.discount,
    quantity: item.quantity ?? 1,
    image_url: item.image_url,
  });
}

export function buildTfPixelPayload(params: {
  currency?: string;
  items?: EcommerceItem[];
  transactionId?: string;
  value?: number;
}): Record<string, unknown> {
  return stripUndefined({
    currency: params.currency,
    transaction_id: params.transactionId,
    value: params.value,
    items: (params.items ?? []).map(mapEcommerceItemToTfPixelItem),
  });
}
